/**
 * FEGO 变量、事件和行为配置
 * 用于对外提供变量、行为和事件，支持在某些场景下不展示表单，通过这些配置完成页面搭建
 */

/** 变量配置 */
export const FEGO_VARIABLES = {
    /** 是否有预约记录 */
    hasReservationRecord: 'hasReservationRecord',

    /** 是否有可预约的时段（排除已预约的时段） */
    hasAvailableTimeSlot: 'hasAvailableTimeSlot',
};

/** 事件名称映射 */
export const EVENT_NAME_MAP = {
    /** 预约成功事件 */
    reservationSuccess: 'reservationSuccess',

    /** 点击喊朋友一起去 */
    clickInviteFriends: 'clickInviteFriends',
};

/** 组件事件列表（用于 behaviourConfig） */
export const eventList = [
    {
        on: EVENT_NAME_MAP.reservationSuccess,
        label: '预约成功',
        eventtype: 'VUE',
    },
    {
        on: EVENT_NAME_MAP.clickInviteFriends,
        label: '点击喊朋友一起去',
        eventtype: 'VUE',
    },
];

/** 行为配置：这里的 method 需要 defineExpose 暴露给 FEGO */
export const behaviorMethods = [
    {
        methodLabel: '执行预约',
        methodName: 'doReservation',
    },
];

/** 组件名称 */
export const CMP_NAME = '通用预约组件';
